module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "vux-demo-header-box",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('x-header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headShow),
      expression: "headShow"
    }],
    attrs: {
      "left-options": {
        backText: ''
      }
    }
  }, [_vm._v(_vm._s(_vm.pageTitle))])], 1), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "任务名称",
      "placeholder": "任务名称",
      "readonly": ""
    },
    model: {
      value: (_vm.showPicker),
      callback: function($$v) {
        _vm.showPicker = $$v
      },
      expression: "showPicker"
    }
  }), _vm._v(" "), (_vm.containsChar3) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader3",
      "label": "转发截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead3,
            "max-count": 10,
            "before-delete": _vm.onDelete3
          },
          model: {
            value: (_vm.uploader3),
            callback: function($$v) {
              _vm.uploader3 = $$v
            },
            expression: "uploader3"
          }
        })]
      },
      proxy: true
    }], null, false, 1265252122)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar4) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader4",
      "label": "在看截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead4,
            "max-count": 10,
            "before-delete": _vm.onDelete4
          },
          model: {
            value: (_vm.uploader4),
            callback: function($$v) {
              _vm.uploader4 = $$v
            },
            expression: "uploader4"
          }
        })]
      },
      proxy: true
    }], null, false, 1797183421)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar1) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader",
      "label": "点赞截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead,
            "max-count": 10,
            "before-delete": _vm.onDelete1
          },
          model: {
            value: (_vm.uploader),
            callback: function($$v) {
              _vm.uploader = $$v
            },
            expression: "uploader"
          }
        })]
      },
      proxy: true
    }], null, false, 308691352)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar2) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader2",
      "label": "评论截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead2,
            "max-count": 10,
            "before-delete": _vm.onDelete2
          },
          model: {
            value: (_vm.uploader2),
            callback: function($$v) {
              _vm.uploader2 = $$v
            },
            expression: "uploader2"
          }
        })]
      },
      proxy: true
    }], null, false, 85007355)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar5) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader5",
      "label": "举报截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead5,
            "max-count": 10,
            "before-delete": _vm.onDelete5
          },
          model: {
            value: (_vm.uploader5),
            callback: function($$v) {
              _vm.uploader5 = $$v
            },
            expression: "uploader5"
          }
        })]
      },
      proxy: true
    }], null, false, 1897404636)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar6) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader6",
      "label": "关注截图上传"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead6,
            "max-count": 10,
            "before-delete": _vm.onDelete6
          },
          model: {
            value: (_vm.uploader6),
            callback: function($$v) {
              _vm.uploader6 = $$v
            },
            expression: "uploader6"
          }
        })]
      },
      proxy: true
    }], null, false, 773669759)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar7) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader7",
      "label": "投票截图1"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead7,
            "max-count": 10,
            "before-delete": _vm.onDelete7
          },
          model: {
            value: (_vm.uploader7),
            callback: function($$v) {
              _vm.uploader7 = $$v
            },
            expression: "uploader7"
          }
        })]
      },
      proxy: true
    }], null, false, 1953914526)
  }) : _vm._e(), _vm._v(" "), (_vm.containsChar8) ? _c('van-field', {
    attrs: {
      "required": "",
      "name": "uploader8",
      "label": "投票截图2"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-uploader', {
          attrs: {
            "after-read": _vm.afterRead8,
            "max-count": 10,
            "before-delete": _vm.onDelete8
          },
          model: {
            value: (_vm.uploader8),
            callback: function($$v) {
              _vm.uploader8 = $$v
            },
            expression: "uploader8"
          }
        })]
      },
      proxy: true
    }], null, false, 2321755953)
  }) : _vm._e(), _vm._v(" "), _c('van-field', {
    attrs: {
      "rows": "2",
      "autosize": "",
      "label": "备注信息",
      "type": "textarea",
      "maxlength": "50",
      "placeholder": "备注信息",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1), _vm._v(" "), _c('van-button', {
    staticClass: "tijiao",
    attrs: {
      "round": "",
      "type": "info",
      "size": "large"
    },
    on: {
      "click": _vm.subConfirm
    }
  }, [_vm._v("提交")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b881b2e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Ttask.vue
// module id = 531
// module chunks = 1